@import '@styles/fonts.scss';

// ── Outer shell ───────────────────────────────────────────────────────────────

.footer {
  background: var(--bg);
  border-top: 1px solid var(--border);
  padding: 0 48px;
}

// ── Top row — 5-column grid ───────────────────────────────────────────────────

.topRow {
  display: grid;
  grid-template-columns: 1.6fr 1fr 1fr 1fr 1fr;
  gap: 48px;
  padding: 56px 0 40px;
}

// ── Brand column ──────────────────────────────────────────────────────────────

.brandCol {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.brandLink {
  display: flex;
  align-items: center;
  gap: 8px;
  text-decoration: none;
  width: fit-content;
}

.mark {
  width: 32px;
  height: 32px;
  flex-shrink: 0;
}

.wordmark {
  font-family: var(--font-display);
  font-size: 20px;
  font-weight: 500;
  font-style: italic;
  letter-spacing: -0.02em;
  color: var(--text);
  line-height: 1;
}

.tagline {
  @include font-body;
  font-size: 13px;
  color: var(--text-muted);
  margin: 0;
  line-height: 1.4;
}

.statusRow {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-top: 4px;
}

.statusDot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #22c55e;
  flex-shrink: 0;
}

.statusLabel {
  @include font-body;
  font-size: 12px;
  color: var(--text-dim);
}

// ── Link columns ──────────────────────────────────────────────────────────────

.linkCol {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.colHeading {
  @include font-mono;
  font-size: 10px;
  text-transform: uppercase;
  letter-spacing: 0.12em;
  color: var(--text-dim);
  margin-bottom: 4px; // adds to the 12px gap = 16px total from heading to first link
}

.link {
  @include font-body;
  font-size: 14px;
  color: var(--text-muted);
  text-decoration: none;
  line-height: 1;
  transition: color 0.15s ease;

  &:hover {
    color: var(--yolk);
  }
}

// ── Separator ─────────────────────────────────────────────────────────────────

.separator {
  height: 1px;
  background: var(--border);
}

// ── Bottom row ────────────────────────────────────────────────────────────────

.bottomRow {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 24px 0;
}

.bottomLeft {
  display: flex;
  align-items: center;
  gap: 16px;
}

.copyright {
  @include font-body;
  font-size: 12px;
  color: var(--text-dim);
}

.version {
  @include font-mono;
  font-size: 10px;
  color: var(--text-dim);
}

.bottomRight {
  display: flex;
  align-items: center;
  gap: 12px;
}

.socialLink {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: var(--text-dim);
  text-decoration: none;
  transition: color 0.15s;

  &:hover {
    color: var(--text-muted);
  }
}

// ── Responsive ────────────────────────────────────────────────────────────────

@media (max-width: 900px) {
  .footer {
    padding: 0 24px;
  }

  .topRow {
    grid-template-columns: 1fr 1fr;
    gap: 32px;
    padding: 32px 0;
  }

  // Brand column spans the full width above the 2-column link grid
  .brandCol {
    grid-column: 1 / -1;
  }

  .bottomRow {
    flex-direction: column;
    align-items: center;
    gap: 16px;
    text-align: center;
  }
}

@media (max-width: 480px) {
  .footer {
    padding: 0 20px;
  }

  .topRow {
    grid-template-columns: 1fr;
    gap: 24px;
  }
}
